import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageHeader: {
    height: "104px",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      height: theme.heightDesktopPageHeader
    }
  },
  appPageContent: {
    display: "grid",
    padding: 0,
    background: "#f6fbfa",
    borderLeft: "1px solid #eeeeee"
  },
  container: {
    flex: "auto",
    width: "100%",
    overflow: "auto",
    position: "relative"
  },
  containerPagination: {
    height: 64,
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${theme.widthTabletDrawer}px)`
    },
    [theme.breakpoints.up("lg")]: {
      width: `calc(100% - ${theme.widthDesktopDrawer}px)`
    }
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    borderRadius: 0,
    padding: "0 24px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 16px"
    }
  },
  topBarTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 19,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 12
    }
  },
  cancelButtonWrapper: {
    textAlign: "right"
  },
  cancelButton: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.secondary,
    fontSize: 16,
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      top: 12,
      right: 16
    }
  }
}));
